import React from 'react';
import { motion } from 'framer-motion';
import { Search, Map, Settings, ArrowRight } from 'lucide-react';
const steps = [{
  num: '01',
  icon: Search,
  title: 'Diagnose',
  desc: 'We review the current business: revenue flow, dispatch, recruiting, back office, compliance, technology, leadership, and strategy.'
}, {
  num: '02',
  icon: Map,
  title: 'Build the Roadmap',
  desc: 'We identify the bottlenecks, prioritize what matters first, and create a clear implementation plan.'
}, {
  num: '03',
  icon: Settings,
  title: 'Install & Account',
  desc: 'We work with your leadership team to implement, track progress, refine systems, and keep momentum moving through recurring accountability.'
}];
export function Framework() {
  return <section id="framework" className="section-padding bg-off-white relative overflow-hidden" data-id="element-141">
      <div className="container-custom relative z-10" data-id="element-142">
        <div className="text-center max-w-3xl mx-auto mb-20" data-id="element-143">
          <span className="eyebrow" data-id="element-144">The FleetScale Framework™</span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-navy mb-6" data-id="element-145">
            A Practical Path From Stuck to Scalable
          </h2>
        </div>

        <div className="relative max-w-5xl mx-auto" data-id="element-146">
          {/* Connecting Route Line for Desktop */}
          <div className="hidden md:block absolute top-12 left-[10%] right-[10%] h-1.5 bg-steel rounded-full z-0 overflow-hidden" data-id="element-147">
            <motion.div initial={{
            scaleX: 0
          }} whileInView={{
            scaleX: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 1.5,
            ease: 'easeInOut'
          }} className="absolute top-0 left-0 h-full bg-red w-full origin-left" data-id="element-148"></motion.div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-12 relative z-10" data-id="element-149">
            {steps.map((step, index) => <motion.div key={index} initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.6,
            delay: index * 0.2
          }} className="relative flex flex-col items-center text-center" data-id="element-150">
                <div className="w-24 h-24 bg-white border-4 border-steel rounded-full flex items-center justify-center mb-8 relative group hover:border-red transition-colors z-10 shadow-lg" data-id="element-151">
                  <span className="absolute -top-4 -right-2 text-3xl font-heading font-black text-steel group-hover:text-red transition-colors bg-off-white px-1" data-id="element-152">
                    {step.num}
                  </span>
                  <step.icon className="w-10 h-10 text-navy" data-id="element-153" />
                </div>

                <h3 className="text-2xl font-bold font-heading text-navy mb-4" data-id="element-154">
                  Step {index + 1}: {step.title}
                </h3>
                <p className="text-body/80 leading-relaxed font-medium px-4" data-id="element-155">
                  {step.desc}
                </p>
              </motion.div>)}
          </div>
        </div>

        <div className="mt-20 text-center" data-id="element-156">
          <a href="#contact" className="btn-primary group" data-id="element-157">
            Schedule a Free Bottleneck Review
            <ArrowRight className="w-4 h-4 ml-2 group-hover:translate-x-1 transition-transform" data-id="element-158" />
          </a>
        </div>
      </div>
    </section>;
}